import {Grid,} from "@mui/material";
import ListaHelado from "./Componentes/SubComponentes/ListaHelado";
import {Helmet} from "react-helmet";

const Seccion_Helados = () => {
    return (
        <>
            <Helmet>
                <title>Helados | Toppings</title>
                <meta
                    name="description"
                    content="Disfruta de los mejores helados en Colón. Variedad de sabores, toppings únicos y combinaciones refrescantes en Toppings."
                />
                <meta
                    name="keywords"
                    content="helados en Colón, mejores helados Colón, postres en Colón, heladerías en Colón, helados artesanales Colón, helados con toppings, helados cerca de mí, helados para llevar Colón"
                />
                <meta name="robots" content="index, follow" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Restaurant",
                        name: "Toppings",
                        image: "https://toppings-colon.web.app/toppings.png",
                        url: "https://toppings-colon.web.app/",
                        telephone: "+57 3132391633",
                        address: {
                            "@type": "PostalAddress",
                            addressLocality: "Colón",
                            addressRegion: "Nariño",
                            addressCountry: "CO"
                        },
                        servesCuisine: ["Comida rápida", "Helados", "Bebidas"],
                        priceRange: "$"
                    })}
                </script>
            </Helmet>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <ListaHelado/>
                </Grid>
            </Grid>
        </>
    )
}
export default Seccion_Helados;

